<template>

  <div class="mb-24">
      <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
        <div class="bg-theme-green px-4 py-2 text-white">
          <div class="flex justify-between items-center">
            <h2 class="font-bold break-all leading-tight text-2xl mt-0 mr-2">New FAQ Entry</h2>
            <div class="flex items-center content-center">
              <button @click="create()" class="text-sm cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white ml-3">
               <span>SAVE</span>
              </button>
              <span @click.prevent="clearComponent" @click="closeAdd" class="cursor-pointer rounded-md  text-white py-2 pl-2  hover:opacity-70">CLOSE</span>
              <!-- <mdicon @click.prevent="clearComponent" size="32" name="close" class="cursor-pointer hover:opacity-60 text-4xl ml-4"/> -->
            </div>
          </div>
        </div>

        <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-b-lg">
          <div class="flex items-center flex-col gap-2 my-2">   
            <div class="w-full">
              <div :class="'input-wrapper ' + (form.question.error_type)">
                <label class="text-xs tracking-[0.4px]">Question</label>
                <input placeholder="Input Your Question Here"  @keyup="validateFields(['question'])" v-model="form.question.value" class="block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm" type="text">
                <p class="field-error label-text mt-1" v-if="form.question.error_message" v-text="form.question.error_message"></p>
              </div>
            </div>
            <div class="w-full">
              <div :class="'input-wrapper ' + (form.answer.error_type)">
                <label class="text-xs tracking-[0.4px]">Answer</label>
                <textarea placeholder="Input Your Answer Here" v-model="form.answer.value" @keyup="validateFields(['answer'])" class="block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm"></textarea>
                <p class="field-error label-text mt-1" v-if="form.answer.error_message" v-text="form.answer.error_message"></p>
              </div>
            </div>
          </div>
        </div>

      </div>
  </div>

  <!-- pop-up -->
  <!-- <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden w-full">
    <div class=" bg-[#464851] px-[16px] py-[16px] rounded-lg">
      <div class="flex justify-center relative gap-3 pb-5">
        <div class="text-3xl pr-8">Are You Sure You Want To Reset?</div>
        <a href="" class="right-0 top-1 absolute"><mdicon size="30px" class="cursor-pointer hover:text-slate-200 " name="close"/></a>
      </div>
      <div class="px-[16px] py-[16px] bg-[#2B2C32] rounded-xl">  
        <div class="flex flex-col justify-center">
          <p class="text-base text-center leading-5 tracking-wider">By confriming this action, you will be resetting your F.A.Q to default questions and answers. This action is irreversable and you won’t be able to recover your existing questions and asnwers</p>
          <div class="flex justify-center mt-4">
            <button class="uppercase rounded-lg bg-theme-green hover:bg-theme-grey hover:text-gray-black text-white w-full py-[14px] text-sm tracking-wider font-medium">confirm</button>
          </div>
        </div>
      </div>
      <div class=" flex justify-center items-center pt-[10px]">
        <button class="uppercase text-sm font-medium tracking-widest text-white hover:text-theme-green">Close</button>
      </div>
    </div>
  </div>  -->
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';
import LoyaltyFaqApis from "@/controllers/LoyaltyFaqApis";

export default defineComponent({
  name: "FaqAdd",
  components: {
  },
  props:{
    loyaltyProgram: {
      type: Object,
      required: true,
    },
    faqCategory: {
      type: Object,
      required: true,
    },
    clearComponent: {
      type: Function,
      required: true,
    },
  },
  setup() {
    const snackbar = useSnackbar();
    const form = ref({
      question: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      answer: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      sort_order: 1,
    });
    return {
      form,
      snackbar
    };
  },

  computed: {
    ...mapGetters({
     
    }),
  },

  mounted() {
     
  },
 
  methods: {
      /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },

    /**
     * Get add
     */
    async create() {
      let validate = await this.validateFields(['question', 'answer', 'sort_order']);
      if(!validate) {
        return ;
      }
      this.va_spinner(true);
      let res = await LoyaltyFaqApis.create(this.loyaltyProgram.id, this.faqCategory.id, Helpers.getFormKeyValue(this.form));
      this.va_spinner(false);
      if(res.status == 201 ) {
        this.clearComponent();
        this.emitter.emit("refresh-faqs-list", true);
      }
      this.snackbar.add({
        type: 'info',
        text: res.status == 201 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>